import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useSelector, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import { action_fetch_add_ticket_order, action_fetch_get_ticket_order, action_fetch_ticket_order_clear, action_fetch_ticket_order_status_change } from "../../../../../store/actions/pages/customer";
import Header from "../../../../components/header";
import { useApp } from "../../../../hooks/common";
import MeLoading from "../../../me/components/loading";
import { SelectType } from "../ticket-detail/components/type-select";
import { OrderList } from "./components/order-list";
import classes from './style.module.scss';

const SubmitButton = props => {
    useStyles(classes)
    const {
        intl,
        linkTo,
        bottomPx,
        isApp
    } = props

    return (
        <div className={classes.SubmitBtn} style={{bottom: isApp? 0: bottomPx(74)}} >
            <span onClick={()=>linkTo()}>
                {intl.formatMessage({id: 'submit'})}
            </span>
        </div>
    )
}

const OrderListPage = props => {
    useStyles(classes)
    const Intl = useIntl()
    const isApp = useApp()
    const history = useHistory()
    const store = useStore()
    const dispatch = useDispatch()
    const { ticketOrder } = useSelector(state => state.pageCustomer)
    const { data, skip, loading, finished } = ticketOrder || {}

    const [paths, setPaths] = useState([
        {label: Intl.formatMessage({id: 'all'}), value: 'all'},
        {label: Intl.formatMessage({id: 'unpaid'}), value: 'unpaid'},
        {label: Intl.formatMessage({id: 'processing'}), value: 'processing'},
        {label: Intl.formatMessage({id: 'shipped'}), value: 'shipped'},
        {label: Intl.formatMessage({id: 'order_status_confirmed'}), value: 'confirmed'},
        {label: Intl.formatMessage({id: 'order_status_canceled'}), value: 'canceled'}
    ])
    const [orderType, setOrderType] = useState('all')
    const [selectedOrderId, setSelectedOrderId] = useState('')
    const lastInitTime = useRef()

    useEffect(async () => {
        // document.body.style.background = "#fff"
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            let time = new Date().getTime()
            if(time != lastInitTime.current){
                await OrderListPage.fetchData(store, null, null)
            } else if(data?.length < 1){
                lastInitTime.current = time
                await OrderListPage.fetchData(store, null, null)
            }
		}
        
        return (() => {
            // document.body.style.background = ''
        })
    }, [])

    const selectChange = async (e) => {
        setOrderType(e)
        await dispatch(action_fetch_get_ticket_order(0, e.value))
    }

    const bottomPx = (px) => `${2 * px / 75 * 1}rem`;

    const linkTo = () => {
        if(selectedOrderId){
            history.push( `/user/faq/support-ticket?id=${selectedOrderId}`)
        }
    }

    const onScroll = async () => {
        await dispatch(action_fetch_add_ticket_order(skip, orderType))
    }

    const clickHandler = async (e, detail) => {
        if( detail?.id == selectedOrderId){
            setSelectedOrderId(null)
        } else {
            setSelectedOrderId(detail?.id)
        }
        await dispatch(action_fetch_ticket_order_status_change(detail?.id))
    }

    return (
        <div className={classes.OrderListPage}>
            <Header centerSlot={Intl.formatMessage({ id: "ticket", defaultMessage: "Ticket" })}/>

            <div className={classes.SelectOrderTitle}>{Intl.formatMessage({id: 'select_order'})}</div>

            <SelectType itemList={paths} selectChange={(e)=>selectChange(e)} type={"order"}/>

            <OrderList orders={data} intl={Intl} request={onScroll} loading={loading} finished={finished} clickHandler={clickHandler} bottomPx={bottomPx} isApp={isApp}/>

            <SubmitButton bottomPx={bottomPx} intl={Intl} isApp={isApp} linkTo={linkTo}/>

            <MeLoading loading={data?.length == 0 && loading}/>
        </div>
    )
}

OrderListPage.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_get_ticket_order(0, 'all', true,  headers))
}

export default OrderListPage